import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownSection, DropdownTrigger, Spinner } from "@heroui/react"
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline"
import { groupBy } from "lodash"
import PropTypes from "prop-types"

const EllipsisDropdown = ({ 
  isLoading = false, 
  items, 
  size = "sm" 
}) => {
  const itemsGroupedBySection = groupBy(items, "section")

  return (
    <div className="relative flex items-center justify-end gap-2">
      <Dropdown>
        <DropdownTrigger>
          <Button isIconOnly size={size} variant="light">
            {isLoading ? <Spinner /> : <EllipsisVerticalIcon className="text-default-300" />}
          </Button>
        </DropdownTrigger>

        <DropdownMenu aria-label="Actions">
          {Object.keys(itemsGroupedBySection).map((key, index) => (
            <DropdownSection 
              showDivider={key !== "undefined" && index+1 < Object.keys(itemsGroupedBySection).length} 
              title={key === "undefined" ? "Actions" : key} 
              key={key}
            >
              {itemsGroupedBySection[key].map(item => (
                <DropdownItem key={item.id} isDisabled={item.isDisabled} onPress={() => item.handleClick()}>
                  {item.caption}
                </DropdownItem>
              ))}
            </DropdownSection>
          ))}
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}

EllipsisDropdown.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
}

export default EllipsisDropdown
